/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum UnitOfMeasure {
    Each = 0,
    Gram = 1,
    Kilogram = 2,
    Millilitre = 3,
    Litre = 4,
}
